export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "dialog": {
          "applicationSent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Application sent, awaiting approval"])},
          "accessAfterApproval": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Access to the course will be sent to the specified email immediately after your installment application is approved"])},
          "goToMain": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go to Home"])}
        }
      },
      "ru": {
        "dialog": {
          "applicationSent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Заявка отправлена, ожидаем одобрения"])},
          "accessAfterApproval": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Доступ к курсу придет на указанный Email сразу после одобрения вашей заявки на рассрочку"])},
          "goToMain": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["На главную"])}
        }
      },
      "es": {
        "dialog": {
          "applicationSent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solicitud enviada, esperando aprobación"])},
          "accessAfterApproval": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["El acceso al curso llegará al correo electrónico indicado inmediatamente después de la aprobación de su solicitud de pago a plazos"])},
          "goToMain": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inicio"])}
        }
      },
      "kk": {
        "dialog": {
          "applicationSent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Өтініш жіберілді, мақұлдауды күтеміз"])},
          "accessAfterApproval": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сіздің бөліп төлеу өтінішіңіз мақұлданғаннан кейін курсқа қол жеткізу электрондық пошта мекенжайына дереу беріледі"])},
          "goToMain": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Басты бетке"])}
        }
      },
      "uz": {
        "dialog": {
          "applicationSent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ariza yuborildi, tasdiqlanishini kutyapmiz"])},
          "accessAfterApproval": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kursga kirish sizning bo‘lib to‘lash bo‘yicha arizangiz tasdiqlangandan so‘ng, ko‘rsatilgan Emailga yuboriladi"])},
          "goToMain": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bosh sahifaga"])}
        }
      },
      "de": {
        "dialog": {
          "applicationSent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Antrag gesendet, wir warten auf die Genehmigung"])},
          "accessAfterApproval": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Zugang zum Kurs wird direkt nach der Genehmigung Ihres Ratenzahlungsantrags an die angegebene E-Mail-Adresse gesendet"])},
          "goToMain": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zur Startseite"])}
        }
      },
      "fr": {
        "dialog": {
          "applicationSent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La demande a été envoyée, en attente d'approbation"])},
          "accessAfterApproval": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L'accès au cours sera envoyé à l'e-mail indiqué dès l'approbation de votre demande de paiement échelonné"])},
          "goToMain": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Accueil"])}
        }
      },
      "it": {
        "dialog": {
          "applicationSent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Domanda inviata, in attesa di approvazione"])},
          "accessAfterApproval": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L'accesso al corso sarà fornito all'email indicata subito dopo l'approvazione della tua richiesta di rateizzazione"])},
          "goToMain": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vai alla home"])}
        }
      }
    }
  })
}
